import { createAction, props } from '@ngrx/store';
import { NavigationModel } from '../../models/navigation/navigation.model';

export const setNavigation = createAction(
  '[Navigation] Set Navigation',
  props<{ payload: NavigationModel }>(),
);
